import React, { useState, useContext } from 'react'
import SmsOptIn from '@pcln/sms-opt-in'
import { Card, Link } from 'pcln-design-system'
import useGetDisclaimer from '@/hooks/smsOptIn/useGetDisclaimer'
import { handleSubmit, SmsPhone } from '@/hooks/smsOptIn/useSubmitSmsOptIn'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import { DisclaimerParams } from '@/hooks/smsOptIn/useSmsDisclaimerQueryArgs'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

const imageUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&auto=avif,webp&dpr=2&orient=2&width=256&crop=3:2,smart'
const altImageText = 'business man in car'
const smallImageUrl =
  'https://s1.pclncdn.com/design-assets/brand-assets/business-man-in-car.jpg?opto&auto=avif,webp&dpr=2&orient=2&width=256&crop=2:3,smart'
const smallImageAltText = 'business man in car'
const headline = 'NEW: Get savings texted to you directly!'
const subheadline = `Provide your phone number and we'll send you special deals and promotions via SMS.`

export default function SmsOptInComponent({
  disclaimerQueryArgs
}: {
  disclaimerQueryArgs: DisclaimerParams
}) {
  const {
    isMobile,
    webstats: { clientGUID }
  } = useContext(BootstrapDataContext)
  const { emailAddress } = disclaimerQueryArgs.disclaimerParams
  const disclaimers = useGetDisclaimer(disclaimerQueryArgs)
  const baseParams = disclaimerQueryArgs.disclaimerParams
  const [signUpState, setSignUpState] = useState('NOT_SIGNED_UP')
  const [signUpSubmitFailureMessage, setSignUpSubmitFailureMessage] = useState<
    string | undefined
  >('')

  const validDisclaimer = disclaimers?.find(
    disclaimer => !disclaimer.optinStatus
  )

  const disclaimerText = validDisclaimer?.disclaimerText?.reduce(
    (previousValue, currentValue) => previousValue + currentValue.text,
    ''
  )

  const disclaimerTextNode = (
    <>
      {validDisclaimer?.disclaimerText?.map(({ text, url }, index) => {
        const uniqueKey = isMobile ? `m${index}` : `d${index}`
        return url ? (
          <Link href={url} target="blank" key={uniqueKey}>
            {text}
          </Link>
        ) : (
          <span key={uniqueKey}>{text}</span>
        )
      })}
    </>
  )

  return (
    <>
      {validDisclaimer && (
        <LayoutComponentWrapper>
          <Card borderRadius="xl" p={4} mb={[2, 0, 4]}>
            <SmsOptIn
              headline={headline}
              subheadline={subheadline}
              imageUrl={imageUrl}
              smallImageUrl={smallImageUrl}
              buttonSize="large"
              textInputRadius="lg"
              signUpState={signUpState}
              imageWidth={1 / 3}
              formWidth={2 / 3}
              disclaimerTextNode={disclaimerTextNode}
              handleFormSubmit={(formData: SmsPhone) =>
                handleSubmit({
                  emailAddress,
                  formData,
                  disclaimerText: disclaimerText || '',
                  baseParams,
                  setSignUpState,
                  setSignUpSubmitFailureMessage,
                  clientGUID
                })
              }
              phoneInputErrorMessage={signUpSubmitFailureMessage}
              altImageText={altImageText}
              smallImageAltText={smallImageAltText}
            />
          </Card>
        </LayoutComponentWrapper>
      )}
    </>
  )
}
